import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GojsComponent } from './gojs/gojs-view.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GojsComponent],
  exports: [
    GojsComponent
  ]
})
export class GojsViewModule { }
